import React from 'react'
import ActionMenu from '../../../ActionMenu'
import { modeList, modeListAppBuilding } from '../../constants'

const AskVisoModes = ({ color, onClick, contextType }) => {
  const modes = contextType === 'appBuilding' ? modeListAppBuilding : modeList

  return (
    <div className='ask-viso-chat-modes'>
      {modes.map((item, index) => (
        <ActionMenu
          key={index}
          onClick={() => onClick(item)}
          icon={item.icon}
          text={item.label}
          color={color}
          badge='AI'
        />
      ))}
    </div>
  )
}

export default AskVisoModes